import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getCurrentPath } from "@faire/web/common/Path";
export var persistUrlParams = function persistUrlParams(url, deleteParams) {
  var urlObject = getCurrentPath();
  if (deleteParams) {
    deleteParams.forEach(function (param) {
      urlObject["delete"](param);
    });
  }
  var params = urlObject.searchParams.toString();
  if (!params) {
    return url;
  }
  var persistedUrl = "".concat(url, "?").concat(params);
  return persistedUrl;
};